import React, { useEffect, useState } from 'react'
import { OnboardSelect } from '../../../components/Onboard/OnboardComponents/Dropdown/Select'
import Filter_Icon from './../../../assets/images/Filter_Icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { getVishingDropdownData, getVishingFormTableData, getVishingValidateTicketNo } from '../../../actions/Applications/heatmap.action';
import { KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import { updateVishingFormDataStart } from './../../../actions/Applications/heatmap.action';
import AdminBreadcrumb from '../../../components/Administration/General/Admin-breadcrumb';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


const VishingTracker = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const RoleId = localStorage.getItem('Role_id');
  const vishingDropdownData = useSelector((state) => state.heatmapReducer.vishingDropdownData);
  const vishingFormTableData = useSelector((state) => state.heatmapReducer.vishingFormTableData);
  const vishingValidateTicketNo = useSelector((state) => state.heatmapReducer.vishingValidateTicketNo);

  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState("");
  const [questionAnswers, setQuestionAnswers] = useState({});
  console.log('vishingValidateTicketNo', vishingValidateTicketNo?.[0]?.duplicate);

  useEffect(() => {
    dispatch(getVishingDropdownData(RoleId));
    dispatch(getVishingFormTableData())
  }, [dispatch, RoleId])

  useEffect(() => {
    if(formData?.TicketNo){
    dispatch(getVishingValidateTicketNo(formData?.TicketNo))
    }
  }, [dispatch, formData?.TicketNo])

  const addValueToFormData = (name, selectedOption) => {
    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: selectedOption,
      };


      if (name === 'Servicedesk') {
        updated.Customer = null;
        updated.Agent = null;
      }

      if (name === 'Customer') {
        updated.Agent = null;
      }

      return updated;
    });
  };
  const serviceDeskOptions = vishingDropdownData?.[0]?.Agents || [];

  const selectedServiceDeskObj = formData?.Servicedesk;
  const customerOptions = selectedServiceDeskObj?.Customer || [];

  const selectedCustomerObj = formData?.Customer;
  const agentOptions = selectedCustomerObj?.Agent || [];

  const Scenarios = vishingDropdownData?.[0]?.MasterScenarios || [];
  const Actions = vishingDropdownData?.[0]?.Actions || [];
  const FailureReasons = vishingDropdownData?.[0]?.FailureReasons || [];
  const Questions = vishingDropdownData?.[0]?.Questions || [];

  const HandleAddUser = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute('name');
    const fieldValue = event.target.value;
    if (fieldValue !== 'Select') {
      const newFormData = { ...formData };
      newFormData[fieldName] = fieldValue;
      setFormData(newFormData)
    }
  }


  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const now = new Date();

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);
  yesterday.setHours(0, 0, 0, 0);


  const getTimeParts = (time) => {
    if (!time) return null;


    if (time.hour) {
      return {
        hours: time.hour(),
        minutes: time.minute(),
      };
    }


    const d = new Date(time);
    return {
      hours: d.getHours(),
      minutes: d.getMinutes(),
    };
  };


  const isValidDateTime = () => {
    if (!selectedDate || !selectedTime) return true;

    const timeParts = getTimeParts(selectedTime);
    if (!timeParts) return true;

    const final = new Date(selectedDate);
    final.setHours(timeParts.hours);
    final.setMinutes(timeParts.minutes);
    final.setSeconds(0);

    const now = new Date();

    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);

    return final >= yesterday && final <= now;
  };
  console.log('formData', formData)

 const handleAssessmentChange = (questionId, selectedOption) => {
  setQuestionAnswers((prev) => ({
    ...prev,
    [`Question${questionId}`]: selectedOption?.Assessment || null
  }));
};

const isFailureCondition = () => {
  const q1 = questionAnswers["Question1"];
  const q2 = questionAnswers["Question2"];

  const isCorrectiveActionFailure =
    formData?.Actions &&
    formData?.Actions?.Actions !== "NA - Process followed by Agent";

  return (
    isCorrectiveActionFailure ||
    q1?.toLowerCase() === "no" ||
    q2?.toLowerCase() === "yes" 
  );
};

  const isFormValid = () => {
    return (
      formData?.Servicedesk &&
      formData?.Customer &&
      formData?.Agent &&
      selectedDate &&
      selectedTime &&
      isValidDateTime() &&
      formData?.Scenario &&
      formData?.SectionOrder &&
      formData?.SectionOrder.trim() !== "" &&
      formData?.Actions &&
      (
  !isFailureCondition() ||
  formData?.FailureReason
) &&
Questions.every(q => questionAnswers[`Question${q.QuestionID}`])
    );
  };

  const resetToNA = () => {
  const defaultAnswers = {};

  Questions.forEach((q) => {
    const naOption = q.Assessments?.find(
      (opt) => opt.Assessment === "NA"
    );

    defaultAnswers[`Question${q.QuestionID}`] =
      naOption?.Assessment || null;
  });

  setQuestionAnswers(defaultAnswers);
};


  const handleAddToTable = () => {

    if (!isFormValid()) {
      if (!isValidDateTime()) {
        setFormError("Please select valid date and time");
      } else {
        setFormError("Please make sure all the * fields are filled");
      }
 window.scrollTo({ top: 0, behavior: 'smooth' });      return;
    }

    if (
  formData?.TicketNo && 
  formData?.TicketNo.trim() !== "" &&
  vishingValidateTicketNo?.[0]?.duplicate === "True"
) {
  setFormError("Ticket Number already exists");
  window.scrollTo({ top: 0, behavior: 'smooth' });
  return;
}

    setFormError("");
    let dispobj = [
      {
        "SevicedeskID": formData?.Servicedesk?.CountryID,
        "CustomerID": formData?.Customer?.AccountID,
        "AgentUserID": formData?.Agent?.UserID,
        "VishingDate": selectedDate,
        "VishingTime": selectedTime,
        "ScenarioID": formData?.Scenario?.ScenarioID,
        "Outcomes": formData?.SectionOrder,
        "TicketNumber":formData?.TicketNo ? formData?.TicketNo : '',
        "Corrective_ActionID": formData?.Actions?.ActionID,
       "FailureID": isFailureCondition()
  ? formData?.FailureReason?.ID
  : null,
        ...questionAnswers    }]
    dispatch(updateVishingFormDataStart(dispobj, () => {
      dispatch(getVishingFormTableData())
    }))
    setFormData({});
    setSelectedDate(null);
    setSelectedTime(null);
    resetToNA();
 window.scrollTo({ top: 0, behavior: 'smooth' });  }

 useEffect(() => {
  if (Questions.length > 0) {
    const defaultAnswers = {};

    Questions.forEach((q) => {
      const naOption = q.Assessments?.find(
        (opt) => opt.Assessment === "NA"
      );

      defaultAnswers[`Question${q.QuestionID}`] =
        naOption?.Assessment || null;
    });

    setQuestionAnswers(defaultAnswers);
  }
}, [Questions]);

  
console.log('mmmmmmmmmmmmmmm',formData)
  return (
    <div>
      <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={false} label3='Vishing Tracker' />

      <section className='App_Layout'>
        <main className='Title_bar'> <div className='Applications_Title'> Vishing Tracker </div></main>
      </section>
      {formError && (
        <div style={{ color: 'red', textAlign: 'left', marginBottom: '10px' }}>
          {formError}
        </div>
      )}
      <section className='Filter_aquaa'>
        <main className='aquaa_filter_img'>
          <img src={Filter_Icon} alt='' style={{ padding: '20px', paddingTop: '30px', paddingLeft: '30px' }} />
        </main>
        <div className='aquaaFilterAlignment' style={{ flexWrap: 'nowrap' }}>
          <main className='Aquaa_dropdown'>
            <label HtmlFor='account'>ServiceDesk *</label>
            <OnboardSelect data={serviceDeskOptions} name='Servicedesk' value='Servicedesk' id='CountryID' marginTop='10px'
              editValue={formData?.Servicedesk} addValueToQueue={addValueToFormData} passFullObject={true} />
          </main>
          <main className='Aquaa_dropdown'>
            <label HtmlFor='contacttypeform'>Account *</label>
            <OnboardSelect data={customerOptions} name='Customer' value='Customer' id='AccountID' marginTop='10px'
              editValue={formData?.Customer} addValueToQueue={addValueToFormData} passFullObject={true} />
          </main>
          <main className='Aquaa_dropdown'>
            <label HtmlFor='contacttypeform'>Agent *</label>
            <OnboardSelect data={agentOptions} name='Agent' value='Agent' id='UserID' marginTop='10px'
              editValue={formData?.Agent} addValueToQueue={addValueToFormData} passFullObject={true} />
          </main>


          <main className='Aquaa_dropdown'>
            <label HtmlFor='contacttypeform'>Select Date *</label>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              inputVariant="outlined"
              format="YYYY-MM-DD"
              label="Select Date"
              value={selectedDate}
              onChange={(date) => {
                setSelectedDate(date);
                setSelectedTime(null);
              }}
              minDate={yesterday}
              maxDate={now}
              fullWidth
            />
          </main>
          <main className='Aquaa_dropdown'>
            <label HtmlFor='contacttypeform'>Select Time *</label>
            <KeyboardTimePicker
              autoOk
              variant="inline"
              inputVariant="outlined"
              label="Select Time"
              value={selectedTime}
              onChange={(time) => {
                setSelectedTime(time);
              }}
              minutesStep={1}
              fullWidth


              shouldDisableTime={(timeValue, clockType) => {
                if (!selectedDate) return false;

                const now = new Date();
                const selected = new Date(selectedDate);

                const isToday =
                  selected.toDateString() === now.toDateString();

                if (!isToday) return false;

                if (clockType === "hours") {
                  return timeValue > now.getHours();
                }

                if (clockType === "minutes") {
                  const timeParts = getTimeParts(selectedTime);

                  if (timeParts && timeParts.hours === now.getHours()) {
                    return timeValue > now.getMinutes();
                  }
                }

                return false;
              }}


              error={selectedDate && selectedTime && !isValidDateTime()}
              helperText={
                selectedDate && selectedTime && !isValidDateTime()
                  ? "Select time between yesterday 12:00 AM and now"
                  : ""
              }
            />
          </main>

        </div>
      </section>

      <section className='scenario_form_section' style={{ padding: '20px', marginBottom: 20 }}>
        <div
          style={{
            display: 'flex',
            gap: '20px',
            height:'370px'
          }}
        >


          <div
            style={{
              flex: 2,
              display: 'flex',
              flexDirection: 'column',
              // alignItems: 'center',
              justifyContent: 'space-between',
              height: '100%'
            }}
          >


            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px',marginLeft:'30%' }}>


              <main className='Aquaa_dropdown' style={{ width: '400px' }}>
                <label style={{ fontWeight: 'bold', color: '#004aac' }}>Scenario *</label>
                <OnboardSelect
                  data={Scenarios}
                  name='Scenario'
                  value='Scenario'
                  id='ScenarioID'
                  marginTop='10px'
                  editValue={formData?.Scenario}
                  addValueToQueue={addValueToFormData}
                  passFullObject={true}
                />
              </main>


              <main style={{ width: '400px', display: 'flex', flexDirection: 'column' }}>
                <label style={{ fontWeight: 'bold', color: '#004aac' }}>Outcome *</label>
                <textarea
                  name='SectionOrder'
                  value={formData?.SectionOrder || ''}
                  onChange={HandleAddUser}
                  placeholder="Outcome"
                  rows="5"
                  style={{ marginTop: '8px' }}
                />
              </main>
              <main style={{ width: '400px', display: 'flex', flexDirection: 'column' }}>
               <div><label style={{ fontWeight: 'bold', color: '#004aac' }}>Ticket Number</label></div>
              <input
              name='TicketNo'
              type="text"
              placeholder="Example: 0123456789"
              value={formData?.TicketNo || ''}
              onChange={HandleAddUser} 
              maxLength={30}
            />
            </main>
              
                <main className='Aquaa_dropdown' style={{ width: '400px' }}>
                  <label style={{ fontWeight: 'bold', color: '#004aac' }}>Corrective Actions *</label>
                  <OnboardSelect
                    data={Actions}
                    name='Actions'
                    value='Actions'
                    id='ActionID'
                    marginTop='10px'
                    editValue={formData?.Actions}
                    addValueToQueue={addValueToFormData}
                    passFullObject={true}
                  />

                </main>
            


              
            </div>
          </div>
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              height: '100%'
            }}
          >
            <label style={{ fontWeight: 'bold', color: '#004aac' }}>Scenario Description</label>

            <div
              style={{
                flex: 1,
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '15px',
                background: '#fafafa',
                overflowY: 'auto'
              }}
            >
              {formData?.Scenario?.Description || "Select a scenario to see description"}
            </div>
          </div>

        </div>
      </section>
    
      
<div style={{ marginTop: '20px', width: '100%',marginLeft:'20.5%' }}>
  <label style={{ fontWeight: 'bold', color: '#004aac' }}>
    Questions *
  </label>

 {Questions.map((q) => (
  <div
    key={q.QuestionID}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      marginBottom: '15px',
    }}
  >
    {/* Question Text */}
    <div style={{width:600}}>
      {q.Question}
    </div>

    {/* Dropdown */}
    <div>
      <OnboardSelect
        data={q.Assessments}
        name={`question_${q.QuestionID}`}
        value="Assessment"
        id="Assessment"
        marginTop="0px"
editValue={questionAnswers[`Question${q.QuestionID}`] || null}
        addValueToQueue={(name, value) =>
          handleAssessmentChange(q.QuestionID, value)
        }
        passFullObject={true}
      />
    </div>
  </div>
))}

{isFailureCondition() && (
   <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '30px'
    }}
  >
  <main className='Aquaa_dropdown' style={{ width: '400px' }}>
    <label style={{ fontWeight: 'bold', color: '#004aac' }}>
      Reason For Failure *
    </label>

    <OnboardSelect
      data={FailureReasons}
      name='FailureReason'
      value='Reason'
      id='ID'
      marginTop='10px'
      editValue={formData?.FailureReason}
      addValueToQueue={addValueToFormData}
      passFullObject={true}
    />
  </main>
   <div
      style={{
        color: 'red',
        fontWeight: 'bold',
        marginTop: '25px'
      }}
    >
      Test Failed
    </div>
  </div>
)}
<div className='btn_adduser' onClick={handleAddToTable}>
                  SUBMIT
                </div>

                
</div>

      

      <section style={{ padding: "20px" }}>
        <table className="aquaa-table">
          <thead>
            <tr>
              {vishingFormTableData.length > 0 &&
                Object.keys(vishingFormTableData[0]).map((key) => (
                  <th key={key}>{key}</th>
                ))}
            </tr>
          </thead>

          <tbody>
            {vishingFormTableData && vishingFormTableData.length > 0 ? (

              vishingFormTableData.map((row, index) => (
                <tr key={index}>
                  {Object.keys(row).map((key) => (
                    <td key={key}>{row[key]}</td>
                  ))}
                </tr>)
              )) : (
              <tr>
                <td colSpan={vishingFormTableData.length}>
                  <section>
                    <div className="noData-para" style={{ marginTop: 0 }}>
                      <div style={{ marginTop: 30 }}>
                        No data available
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </section>


    </div>
  )
}

export default VishingTracker
